// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent, setUserProperties, setUserId} from "firebase/analytics";
import { getUserDetails } from "./authUtils";

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_ANALYTICS_API_KEY,
  authDomain: process.env.REACT_APP_ANALYTICS_AUTHDOMAIN,
  projectId: process.env.REACT_APP_ANALYTICS_PROJECTID,
  storageBucket: process.env.REACT_APP_ANALYTICS_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_ANALYTICS_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_ANALYTICS_APPID,
  measurementId: process.env.REACT_APP_ANALYTICS_MEASUREMENTID
};

const userAttributesToInclude = {
    'EmailAddress': true,
    'FullName': true,
    'Id': true,
    'OrgCode': true,
    'Role': true
}

// Tenants that have opted out of Google Analytics entirely, as a comma separated
// list of org codes baked in at build time (Bitbucket deployment variable).
// Empty/absent means GA stays enabled for everyone, i.e. no behaviour change.
const disabledOrgs = new Set(
    (process.env.REACT_APP_ANALYTICS_DISABLED_ORGS || '')
        .split(',')
        .map(orgCode => orgCode.trim().toUpperCase())
        .filter(Boolean)
);

let blocked = null;

// The firebase SDK only injects the googletagmanager gtag script on the first
// getAnalytics() call, so gating every getAnalytics() call here blocks GA
// completely: no script download, no cookies, no hits. OrgCode comes from
// localStorage synchronously, so it is already known by the time anything
// renders.
const isBlocked = () => {
    if (disabledOrgs.size === 0) return false;
    if (blocked === null) {
        const orgCode = getUserDetails()?.OrgCode;
        // Until the tenant is known, stay blocked rather than risk a leak, and
        // do not memoise so a later call can resolve it properly.
        if (!orgCode) return true;
        blocked = disabledOrgs.has(String(orgCode).trim().toUpperCase());
    }
    return blocked;
}

// initializeApp is deliberately unconditional: it loads no gtag, sets no cookies
// and makes no network call, and gating it would leave a later getAnalytics() to
// throw on an uninitialised app if the tenant only resolves after mount.
const init = () => {
    initializeApp(firebaseConfig);
}

const sendEvent = (action, payload) => {
    if (process.env.NODE_ENV === "production") {
        if (isBlocked()) return;
        const analytics = getAnalytics();
        const finalPayload = {
            project: "casa_end_user_dashboard",
            ...payload
        }
        logEvent(analytics, action, finalPayload);
    }
}

const setUser = (user) => {
    if (!user || isBlocked()) return;
    const analytics = getAnalytics();
    setUserId(analytics, user.Id);
    for (let key in user) {
        const userProp = { [key]: user[key]}
        if(userAttributesToInclude[key]) {
            setUserProperties(analytics, userProp);
        }
    }
}
export default {
    init,
    sendEvent,
    setUser,
}
